import type { CaseKind } from "./types";

export const caseKindLabels: Record<CaseKind, string> = {
  OFFLINE_EVENT: "线下活动",
  H5: "线上 H5",
  MINI_PROGRAM: "小程序",
};

export function caseNeedsQr(kind: CaseKind): boolean {
  return kind === "H5" || kind === "MINI_PROGRAM";
}

